import { Navigation } from './Navigation';
import { useLayoutTier } from '../hooks/useLayoutTier';

export function SidebarDesktop() {
  const { isDesktopTier } = useLayoutTier();

  if (!isDesktopTier) {
    return null;
  }

  return (
    <aside
      className='bg-brand-primary top-header-height fixed flex
        h-[calc(100dvh-var(--spacing-header-height))]
        w-(--spacing-sidebar-width) flex-col overflow-y-auto pt-8 pb-6'
    >
      <Navigation />
    </aside>
  );
}
